import { render, staticRenderFns } from "./MyFan.vue?vue&type=template&id=ca2d2c74&scoped=true&"
import script from "./MyFan.vue?vue&type=script&lang=js&"
export * from "./MyFan.vue?vue&type=script&lang=js&"
import style0 from "./MyFan.vue?vue&type=style&index=0&id=ca2d2c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d2c74",
  null
  
)

export default component.exports